import { render, staticRenderFns } from "./pictures-content.vue?vue&type=template&id=705b0983&"
import script from "./pictures-content.vue?vue&type=script&lang=js&"
export * from "./pictures-content.vue?vue&type=script&lang=js&"
import style0 from "./pictures-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports